import { withStyles } from '@material-ui/core';

import Settings from './component';
import styles from './styles';

export default withStyles(styles)(Settings);
